import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import {Map, List} from 'immutable';

import * as BetTypeMap from 'constants/BetType';

import {setCouponAmount as setCouponAmountAction} from 'actions/creators/CouponRate';
import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';
import {beginSignIn as beginSignInAction, beginJoin as beginJoinAction} from 'actions/creators/Auth';

import BetType from './BetType.jsx';
import FavouriteBetAmount from './FavouriteBetAmount.jsx';

import {minAmount as MinAmountValues} from 'constants/StakeMinAmount';
import {maxWinAmount as MaxWinAmountValues} from 'constants/StakeMaxWinAmount';

import {resourceNames} from 'constants/accountResourceNames';
import { STAKES_VALUES } from '../CouponDropDownMenu.jsx';

const messages = defineMessages({
    makeBet: {
        id: 'coupon.make_bet',
        defaultMessage: 'Сделать ставку'
    },
    confirmRateValueChange: {
        id: 'coupon.confirm_rate_value_change',
        defaultMessage: 'Принять'
    },
    totalOdd: {
        id: 'coupon.total_odd_hint',
        defaultMessage: 'Общий коэффициент'
    },
    possibleWinning: {
        id: 'coupon.possible_winning_hint',
        defaultMessage: 'Возможный выигрыш'
    },
    stake: {
        id: 'coupon.stake_hint',
        defaultMessage: 'Сумма ставки'
    },
    minAmountHint: {
        id: 'coupon.min_amount_hint',
        defaultMessage: 'Мин.'
    },
    maxAmountHint: {
        id: 'coupon.max_amount_hint',
        defaultMessage: 'Макс. {amount} {resource}'
    },
    to_place_bet: {
        id: 'betpanel.unauth.to_place_bet',
        defaultMessage: 'Чтобы сделать ставку - '
    },
    should_auth: {
        id: 'betpanel.unauth.should_auth',
        defaultMessage: 'войдите'
    },
    should_register: {
        id: 'betpanel.unauth.should_register',
        defaultMessage: 'зарегистрируйтесь'
    },
    auth_or_register_to_bet: {
        id: 'betpanel.unauth.auth_or_register_to_bet',
        defaultMessage: '{signTrigger} или {joinTrigger}'
    }
});

class UnauthControls extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        user: React.PropTypes.object,
        betSlips: React.PropTypes.object,
        currentBetTypeIndex: React.PropTypes.number.isRequired,
        betTypes: React.PropTypes.object,
        amount: React.PropTypes.number,
        minBetAmount: React.PropTypes.number,
        bettingMode: React.PropTypes.object,
        nextKey: React.PropTypes.number,
        setCouponAmountAction: React.PropTypes.func.isRequired,
        requestBetTypesAction: React.PropTypes.func.isRequired,
        beginSignInAction: React.PropTypes.func.isRequired,
        beginJoinAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        const inActive = (props.amount < props.minBetAmount);
        const rawAmount = props.amount;

        this.state = {inActive, rawAmount};

        this._onAmountChange = this._onAmountChange.bind(this);
        this._onFavouriteBetAmountClick = this._onFavouriteBetAmountClick.bind(this);
        this._handleLogInClick = this._handleLogInClick.bind(this);
        this._handleJoinClick = this._handleJoinClick.bind(this);
    }

    _handleLogInClick(e) {
        e.preventDefault();
        this.props.beginSignInAction();
    }

    _handleJoinClick(e) {
        e.preventDefault();
        this.props.beginJoinAction();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.languageId !== this.props.languageId ||
            nextProps.betSlips !== this.props.betSlips ||
            nextProps.amount !== this.props.amount ||
            nextProps.currentBetTypeIndex !== this.props.currentBetTypeIndex ||
            nextProps.betTypes !== this.props.betTypes ||
            nextProps.bettingMode !== this.props.bettingMode ||
            nextProps.nextKey !== this.props.nextKey ||
            nextState.rawAmount !== this.state.rawAmount;
    }

    static transform(rates) {
        let transformedRates = new List();

        rates.valueSeq().forEach(rate => {
            transformedRates = transformedRates.push(UnauthControls.transformBetSlip(rate));
        });

        return transformedRates;
    }

    static transformBetSlip(betSlip) {
        const rate = betSlip.get('rate');

        return new Map({
            eventId: rate.get('matchId'),
            eventTimeAndZone: betSlip.getIn(['match', 'timeAndZone']),
            outcomeId: rate.get('outcomeId'),
            factorId: rate.get('id'),
            factorValue: rate.get('value'),
            isConditional: false
        });
    }

    _onFavouriteBetAmountClick(amount) {
        this.props.setCouponAmountAction(amount);
        this.setState({inActive: false, rawAmount: amount});
    }

    _onAmountChange(e) {
        e.preventDefault();

        const {minBetAmount} = this.props;
        let rawAmount = e.target.value;

        // checking for length
        if (!rawAmount.length) {
            this.setState({inActive: true, rawAmount: ''});
            this.props.setCouponAmountAction(0);
        }

        const amount = Number(rawAmount);

        if (isNaN(amount)) {
            return;
        }

        const splittedRawAmount = rawAmount.split('.');
        const zeroSum = (splittedRawAmount[0].length > 1 && amount == 0.0);
        const longDecimalPart = (splittedRawAmount[1] !== undefined && splittedRawAmount[1].length > 2);

        // checking for several zeros and long decimal part of value
        if (zeroSum || longDecimalPart) {
            return;
        }

        // concating splitted value to normal amount
        rawAmount = Number(splittedRawAmount[0]).toString();
        if (splittedRawAmount[1] !== undefined) {
            rawAmount = rawAmount + '.' + splittedRawAmount[1];
        }

        const splittedAmount = amount.toString().split('.');
        const ceilPart = splittedAmount[0];
        const decimalPart = splittedAmount[1] !== undefined ? splittedAmount[1] : '';

        // checking for fract.num length
        if ((ceilPart.toString().length > 7) || (decimalPart.toString().length > 2)) {
            return;
        }

        this.setState({inActive: (amount < minBetAmount), rawAmount});
        this.props.setCouponAmountAction(amount);
    }

    render() {
        const {inActive, rawAmount} = this.state;
        const {
            bettingMode,
            betSlips,
            betTypes,
            currentBetTypeIndex,
            amount,
            minBetAmount,
            maxWinAmount,
            resourceName,
            countryCode
        } = this.props;
        const currentBetType = betTypes.get(currentBetTypeIndex);
        const betType = betTypes.get(currentBetTypeIndex);
        const currentBetTypeIsSingle = (betType && betType.type == BetTypeMap.SINGLE);

        const odd = currentBetType ? currentBetType.odd : 0;

        let possibleWinAmount = 0;

        if (amount && !isNaN(amount)) {
            possibleWinAmount = (amount * odd).toFixed(2);
        }

        if (betType && betType.type == BetTypeMap.SYSTEM && betType.rank !== undefined) {
            possibleWinAmount = (amount * odd).toFixed(2);
        }

        const maxRestriction = possibleWinAmount > maxWinAmount;

        const values = STAKES_VALUES[countryCode]
        const favouriteBet1Amount = bettingMode.get('favouriteBet1Amount') || values[1];
        const favouriteBet2Amount = bettingMode.get('favouriteBet2Amount') || values[2];
        const favouriteBet3Amount = bettingMode.get('favouriteBet3Amount') || values[3];

        const signTrigger = (
            <FormattedMessage {...messages.should_auth}>
                {(message) => <a className="trigger" onClick={this._handleLogInClick}>{message}</a>}
            </FormattedMessage>

        );

        const joinTrigger = (
            <FormattedMessage {...messages.should_register}>
                {(message) => <a className="trigger" onClick={this._handleJoinClick}>{message}</a>}
            </FormattedMessage>
        );

        return (
            <div className="coupon-controls">
                <BetType/>
                <FormattedMessage {...messages.totalOdd}>
                    {(message) =>
                        <div className="rate" title={message}>
                            <span>{odd.toFixed(2)}</span>
                        </div>
                    }
                </FormattedMessage>
                <FormattedMessage {...messages.possibleWinning}>
                    {(message) =>
                        <div className="balance" title={message}>
                            <span>{possibleWinAmount}</span>
                        </div>
                    }
                </FormattedMessage>
                {maxRestriction && <FormattedMessage {...messages.maxAmountHint }
                                                     values={{amount: maxWinAmount, resource: resourceName}}>
                    {(message) => <p className="max-win-amount-hint">{message}</p>}
                </FormattedMessage>}
                <FormattedMessage {...messages.stake}>
                    {(message) =>
                        <div className="bet-amount cf" title={message}>
                            <input ref="betAmount" value={rawAmount} type="text" id="bet-amount" className="bet"
                                   onChange={this._onAmountChange} onBlur={this._onAmountChange}/>
                            <FormattedMessage {...messages.minAmountHint}>
                                {(message) =>
                                inActive && <p className="min-bet-amount-hint">{message} {minBetAmount}</p>}
                            </FormattedMessage>
                            {(!inActive && currentBetTypeIsSingle && betSlips.size > 1) &&
                            <p className="total-rates"> X {betSlips.size} = <strong>{amount * betSlips.size}</strong>
                            </p>}
                        </div>}
                </FormattedMessage>
                <div className="favourites-bet-amounts cf">
                    <FavouriteBetAmount number={1}
                                        amount={favouriteBet1Amount}
                                        callback={this._onFavouriteBetAmountClick}/>
                    <FavouriteBetAmount number={2}
                                        amount={favouriteBet2Amount}
                                        callback={this._onFavouriteBetAmountClick}/>
                    <FavouriteBetAmount number={3}
                                        amount={favouriteBet3Amount}
                                        callback={this._onFavouriteBetAmountClick}/>
                </div>
                <div className="not-auth-bet-control-message">
                    <p className="attention">
                        <FormattedMessage {...messages.to_place_bet} />
                    </p>
                    <p className="links">
                        <FormattedMessage {...messages.auth_or_register_to_bet} values={{signTrigger, joinTrigger}}/>
                    </p>
                </div>
            </div>);
    }
}

function select(state) {
    let defaultResourceId = 4;
    const countryCode = state.application.get('countryCode');
    const languageId = state.application.get('languageId');
    const user = state.auth.get('user');
    const betSlips = state.application.getIn(['coupon', 'betSlips']);
    const betTypes = state.application.getIn(['coupon', 'betTypes']);
    const currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
    const amount = state.application.getIn(['coupon', 'amount']);
    const bettingMode = state.application.getIn(['bettingMode']);
    const betHistory = state.application.getIn(['betHistory']);
    const nextKey = betHistory.size > 0 ? (parseInt(betHistory.keySeq().maxBy(x => parseInt(x))) + 1) : 1;

    if(countryCode === 'KG') defaultResourceId = 1;
    if(countryCode === 'UZ') defaultResourceId = 15;
    const resourceName = (user === undefined || !user) ? resourceNames[defaultResourceId] : resourceNames[user.get('resourceId')];
    const minBetAmount = MinAmountValues[resourceName];
    const maxWinAmount = MaxWinAmountValues[resourceName];

    return {
        countryCode,
        languageId,
        user,
        betSlips,
        betTypes,
        currentBetTypeIndex,
        amount,
        bettingMode,
        nextKey,
        minBetAmount,
        maxWinAmount,
        resourceName
    };
}

export default connect(select, {
    setCouponAmountAction,
    requestBetTypesAction,
    beginSignInAction,
    beginJoinAction
})(UnauthControls);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/UnauthControls.jsx